export default class Auth {
    static STORAGE_KEY: string = "token";
    static ROLE_KEY: string = "userRole"
    static REGISTERED_KEY: string = "registered"
    static PERSONAL_NUMBER: string = "personalNr"
    static NAMES: string = 'names'
    static LONHABZUGBERECHTIGT = "isLonhabzugberechtigt"

    static getToken() {
        return window.localStorage.getItem(Auth.STORAGE_KEY);
    }

    static setToken(token: string) {
        window.localStorage.setItem(Auth.STORAGE_KEY, token);
    }

    static removeToken(): void {
        window.localStorage.removeItem(Auth.STORAGE_KEY);
    }

    static getRole() {
        return window.localStorage.getItem(Auth.ROLE_KEY)
    }

    static setRole(role: string, registered: boolean) {
        window.localStorage.setItem(Auth.ROLE_KEY, role)
        window.localStorage.setItem(Auth.REGISTERED_KEY, registered.toString())
    }

    static removeRole(): void {
        window.localStorage.removeItem(Auth.ROLE_KEY)
        window.localStorage.removeItem(Auth.REGISTERED_KEY)
    }

    static getRegistered(): string {
        return window.localStorage.getItem(Auth.REGISTERED_KEY)
    }

    static setPersonalNr(personalNr: string) {
        window.localStorage.setItem(Auth.PERSONAL_NUMBER, personalNr)
    }

    static getPersonalNr(): string {
        return window.localStorage.getItem(Auth.PERSONAL_NUMBER)
    }

    static removePersonalNr() {
        window.localStorage.removeItem(Auth.PERSONAL_NUMBER)
    }

    static setIsLonhabzugberechtigt(isLonhabzugberechtigt: boolean): void {
        window.localStorage.setItem(Auth.LONHABZUGBERECHTIGT, `${isLonhabzugberechtigt}`)
    }

    static getIsLonhabzugberechtigt(): string {
        return window.localStorage.getItem(Auth.LONHABZUGBERECHTIGT)
    }

    static removeIsLonhabzugberechtigt(): void {
        window.localStorage.removeItem(Auth.LONHABZUGBERECHTIGT)
    }
}
